import {isChooseMultipleSeatsMode, isChooseSeatMode} from '../../../../selectors/navigation'
import {isInAccessibilityMode} from '../../../../selectors/seating/mode'
import {getFilteredPlacesCount} from '../../../../selectors/seating/places'
import {DetailsPageAppProps} from '../../../app/interfaces'
import {connect} from '../../../runtime-context/context'
import {AccessibilityMode as Presentation} from './accessibility-mode'
import {AccessibilityModeOwnProps, AccessibilityModeRuntimeProps} from './interfaces'

const mapRuntime = ({
  state,
  actions: {setShowAccessibilityMode},
}: DetailsPageAppProps): AccessibilityModeRuntimeProps => ({
  showAccessibilityMode: isInAccessibilityMode(state),
  setShowAccessibilityMode,
  placesCount: getFilteredPlacesCount(state),
  chooseSeatMode: isChooseSeatMode(state),
  chooseMultipleSeatsMode: isChooseMultipleSeatsMode(state),
})

export const AccessibilityMode = connect<AccessibilityModeOwnProps, AccessibilityModeRuntimeProps>(mapRuntime)(
  Presentation,
)

export * from './interfaces'
